import Status from './views/Status.vue';

const routes = [
  {
    path: '/status/',
    name: 'Status-Index',
    component: Status,
    meta: {
      requiresAuth: true,
      title: 'Status do Sistema',
    },
  },
];

export default routes;
